export default __webpack_public_path__ + "static/media/maze-right.17d7a545.svg";